import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { UserCreditCardResponse } from '../../responses/platform/user-credit-card.response';

@Injectable({
  providedIn: 'root'
})
export class UserCreditCardService extends CommonService {
  constructor(private http: HttpClient) {
    super();
  }

  public getUserCreditCards(): Observable<UserCreditCardResponse> {
    return this.http
      .get<UserCreditCardResponse>(
        environment.urlApiPlatform + "CreditCard",
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }
}
